<div class="h-100">
    <div class="py-2 d-flex flex-row justify-content-between modal-header">
       <app-scout-header [scoutTaskDoc]="scoutTaskDoc"></app-scout-header>
       <i class="pr-2 fa fa-times" role="button" (click)="onCloseModal()"></i>
    </div>
    <div class="kml-viewer-modal-content" style="height: calc(100% - 76px);">
      <fes-scout-kml-viewer #scout3d [scoutTaskDoc]="scoutTaskDoc" [pathIds]="pathIds" (close)="onCloseModal()">
      </fes-scout-kml-viewer>
    </div>
</div>